import * as types from './types'
import { createAction } from 'Utils/redux'

export const loadLanguages = createAction(types.LOOKUP_LOAD_LANGUAGES)
export const setLanguages = createAction(types.LOOKUP_SET_LANGUAGES, 'data')
